declare namespace $ {

	export class $mol_icon_blur extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=blur.view.tree.d.ts.map